import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'html'
})
export class HtmlPipe implements PipeTransform  {
  transform(value) {
    return value.split('< ').join('<');
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/html.pipe.ts